(ns ui.tooltip
  (:require
   ["@radix-ui/react-tooltip" :as RadixTooltip]
   [ui.utils :refer [clsx separate-props]]))

(defn tooltip-root [& args]
  (let [[props children] (separate-props args)
        {:keys [disabled provider]} props]
    [:> RadixTooltip/Provider provider
     (into [:> RadixTooltip/Root (cond-> (dissoc props :disabled :provider)
                                   disabled (assoc :open false))]
           children)]))

(defn tooltip-trigger [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixTooltip/Trigger props]
          children)))

(defn tooltip-content [& args]
  (let [[props children] (separate-props args)]
    [:> RadixTooltip/Portal
     [:> RadixTooltip/Content (update props
                                      :class #(clsx "z-999999 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm shadow-md bg-white dark:bg-kleene-dark-02 border-kleene-neutral-05 dark:border-kleene-dark-03 max-w-xs"
                                                    %))
      (into [:<>] children)
      [:> RadixTooltip/Arrow {:class "fill-kleene-neutral-05 dark:fill-kleene-dark-03"}]]]))

(defn tooltip
  [{:keys [content trigger-as-child class content-props trigger-props]
    :or   {trigger-as-child true}
    :as    props}
   children]
  [tooltip-root (dissoc props :content :content-props :trigger-props :disabled :trigger-as-child :class)
   [tooltip-trigger (assoc trigger-props :as-child trigger-as-child)
    children]
   [tooltip-content
    (assoc content-props :class class)
    content]])
